/** heal.png flash on general portrait — Recover heals, Viral Echo, Redeem, etc. */

export const GENERAL_HEAL_FLASH_IMAGE_SRC = '/images/heal.png';
export const GENERAL_HEAL_FLASH_DURATION_MS = 2000;
